import {
  Box,
  Button,
  Card,
  CardContent,
  IconButton,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableContainer,
  TextField,
  Tooltip,
} from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import Iconify from 'src/components/iconify';
import Scrollbar from 'src/components/scrollbar';
import {
  emptyRows,
  getComparator,
  TableEmptyRows,
  TableHeadCustom,
  TableNoData,
  TablePaginationCustom,
  TableSelectedAction,
  useTable,
} from 'src/components/table';
import { useBoolean } from 'src/hooks/use-boolean';
import Header from '../header';
import { LoadingButton } from '@mui/lab';
import { Typography } from '@mui/material';
import { isEqual } from 'lodash';
import { CSVLink } from 'react-csv';
import { ConfirmDialog } from 'src/components/custom-dialog';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
import { LoadingScreen } from 'src/components/loading-screen';
import { baseURLnav } from 'src/config-global';
import { deleteRequest, getRequest, postRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';
import ImportDilaog from '../../import-modal';
import ProjectList from '../../project-list/project-list-modal';
import { getCsvData } from './getCsv-invoice';
import UserTableRow from './invoice/invoices-table-row';
import SettingModal from './invoice/settings-modal';

const Invoice = () => {

  const [loading, setLoading] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [actionVisible, setActionVisible] = useState(true); 
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [projectList, setprojectList] = useState([]);
  const [selectedProject, setSelectedProject] = useState('All');
  const [tableData, setTableData] = useState([]);
  const [chartsAccountList, setchartsAccount] = useState([]);
  const [bankInformation, setBankInformation] = useState([]);

  const popover = usePopover();
  const popoverDots = usePopover();

  const TABLE_HEAD = [
    { id: 'sr_no', key: 'sr_no', label: 'Sr.No' },
    { id: 'invoice_number', key: 'invoice_number', label: 'Invoice Number' },
    { id: 'customer_id', key: 'customer_id', label: 'Customer' },
    { id: 'project', key: 'project_name', label: 'Project Name' },
    { id: 'invoice_date', key: 'billing_date', label: 'Billing Date' },
    { id: 'due_date', key: 'due_date', label: 'Due Date' },
    { id: 'total', key: 'amount', label: 'Amount' },
    { id: 'amount_received', key: 'amount_received', label: 'Amount Received' },
    { id: 'balance_due', key: 'balance_due', label: 'Balance Due' },
    { id: 'note', key: 'notes', label: 'Notes/Remarks' },
    { id: 'status', key: 'status', label: 'Status' },
  ];

  const table = useTable();
  const remove = useBoolean();
  const add = useBoolean();
  const confirm = useBoolean();
  const create = useBoolean();
  const modal = useBoolean();
  const update = useBoolean();


  const [filters, setFilters] = useState({
    customer_id: null,
    project_name: '',
    account_chart: '',
    account_chart_name: '',
    account_chart_account_type_name: '',
    invoice_number: '',
  });

  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const handleCloseFilters = () => {
    popover.onClose();
    setFilters({
      customer_id: null,
      project_name: '',
      account_chart: '',
      account_chart_name: '',
      account_chart_account_type_name: '',
      invoice_number: '',
    })
  }

  const csvLinkRef = useRef();

  const dataFiltered = applyFilter({
    inputData: tableData.length > 0 ? tableData : [],
    comparator: getComparator(table.order, table.orderBy),
    filters,
  });
  console.log("🚀 ~ Customers ~ tableData:", tableData)
  const dataInPage = dataFiltered.slice(
    table.page * table.rowsPerPage,
    table.page * table.rowsPerPage + table.rowsPerPage
  );
  const denseHeight = table.dense ? 52 : 72;
  const canReset = !isEqual({ name: '', role: [], status: 'all' }, filters);
  const notFound = (!dataFiltered.length && canReset) || !dataFiltered.length;

  useEffect(() => {
    getInvoice(selectedProject);
    getProjects();
    getChartsOfAccount();
    getBankInformation();
  }, []);

  const getInvoice = async (projectId) => {
    setLoading(true);
    const endpoint = projectId && projectId !== 'All'
      ? `${endpoints.accounting.account_receiveable.invoice.get_list}?project_id=${projectId}`
      : endpoints.accounting.account_receiveable.invoice.get_list;

    const data = await getRequest(endpoint);
    console.log('🚀 ~    ~ data:', data);
    setLoading(false);
    if (data) {
      setTableData(data?.invoices);
    }
  };

  const getProjects = async () => {
    const data = await getRequest(endpoints.accounting.expenses.get_project_list);
    console.log('🚀 ~ getProjets ~ data:', data);
    if (data) {
      setprojectList(data);

    }
  };
  const getBankInformation = async () => {
    const data = await getRequest(endpoints.accounting.bank_information.get_list);
    console.log(' getBankInformation ~ data:', data);
    if (data) {
      setBankInformation(data);
    }
  };

  const getChartsOfAccount = async () => {
    const data = await getRequest(endpoints.accounting.expenses.charts_of_account_list);
    console.log("🚀 ~ getCostCenter ~ data:", data)
    if (data) {
      setchartsAccount(data);
    }
  };

  const handleChange = (event) => {
    const projectId = event.target.value;
    setSelectedProject(projectId);
    getInvoice(projectId);
  };
  const deleteCallBack = () => {
    confirm.onFalse();
    getInvoice();
  };

  const handleDeleteRows = async (id) => {
    await deleteRequest(
      `${endpoints.risk_management.risk_change_request.crud}/${selectedItem.id}`,
      deleteCallBack
    );
    const updatedTableData = tableData.filter((row) => row.id !== id);
    setTableData(updatedTableData);
    if (updatedTableData.length <= table.page * table.rowsPerPage && table.page > 0) {
      table.onChangePage(null, table.page - 1);
    } else {
      table.onUpdatePageDeleteRow(dataInPage.length);
    }
  };
  const getCsvHeaders = () => {
    return TABLE_HEAD.filter(({ id }) => id !== 'action' && id !== 'sr_no').map(({ id, label }) => ({
      label,
      key: id,
    }));
  };

  const handleExport = () => {
    if (csvLinkRef.current) {
      const csvData = getCsvData(tableData);
      csvLinkRef.current.link.click(csvData);
    }
  };

  const handleBulkDelete = async () => {
    const Ids = table.selected;
    console.log('🚀 ~ handleBulkDelete ~ Ids:', Ids);
    if (Ids.length > 0) {
      try {
        const response = await postRequest(
          endpoints.risk_management.risk_change_request.bulk_delete,
          { ids: Ids }
        );
        console.log('🚀 ~ handleBulkDelete ~ response:', response);
        remove.onFalse();
        setActionVisible(false);
        getInvoice();
      } catch (error) {
        console.error('Error during bulk delete:', error);
      }
    } else {
      console.warn('No rows selected');
    }
  };
  return (
    <>
      <Card sx={{ height: '100%', marginTop: '10px', overflow: 'hidden' }}>
        {' '}
        <CardContent>
          {loading ? (
            <Box height={700}>
              <LoadingScreen />
            </Box>
          ) : (
            <>
              <Header name="Accounts Receivable" />
              <div
                style={{
                  backgroundColor: '#F4F6F8',
                  border: '1px solid #FFD700',
                  padding: '10px 10px',
                  borderRadius: '5px',
                  marginTop: '15px',
                  marginBottom: '35px',
                }}
              >
                <Typography
                  variant="caption"
                  sx={{
                    marginLeft: '1px',
                    fontSize: '15px',
                    whiteSpace: 'pre-line',
                  }}
                >
                  <strong>Note:</strong>
                  If you want to create new data,{' '}
                  <a
                    href={`${baseURLnav}/invoices`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: 'none', fontWeight: 'bold' }}
                  >
                    click here
                  </a>.
                  This will open the project list, where you can select a Project. Once selected, you will be redirected accordingly.
                </Typography>

              </div>

              <Box
                sx={{
                  display: 'flex',
                  paddingBottom: '20px',
                  justifyContent: 'space-between',
                  gap: '12px',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    padding: '5px 0',
                  }}
                >
                  <h5
                    style={{
                      fontSize: '14px',
                      fontWeight: '400',
                      color: '#333',
                      margin: '0',
                      textTransform: 'none',
                    }}
                  >
                    Project Name
                  </h5>
                  <Select
                    sx={{ minWidth: 65, height: 35 }}
                    value={selectedProject}
                    onChange={handleChange}
                  >
                    <MenuItem value="All">All</MenuItem>
                    {projectList?.map((project) => (
                      <MenuItem key={project.id} value={project.id}>
                        {project.name}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>

                <Box
                  sx={{
                    display: 'flex',
                    paddingBottom: '20px',
                    justifyContent: 'flex-end',
                    gap: '12px',
                  }}
                >
                  <Button
                    onClick={popover.onOpen}
                    className="dark-button"
                    variant="contained"
                    sx={{ mx: 1 }}
                    startIcon={<Iconify icon="mdi:filter" />}
                  >
                    Filter
                  </Button>
                  {/* <Button
                    onClick={modal.onTrue}
                    className="dark-button"
                    variant="contained"
                    startIcon={<Iconify icon="mingcute:add-line" />}
                  >
                    Settings
                  </Button> */}
                  <IconButton onClick={popoverDots.onOpen}>
                    <Iconify icon="eva:more-vertical-fill" />
                  </IconButton>
                </Box>
              </Box>
              <CustomPopover
                open={popoverDots.open}
                onClose={popoverDots.onClose}
                arrow="right-top"
                sx={{ width: 140 }}
              >
                <MenuItem
                  onClick={() => {
                    handleExport();
                    popoverDots.onClose();
                  }}
                >
                  <Iconify icon="solar:export-bold" />
                  Export
                </MenuItem>
              </CustomPopover>

              <CustomPopover
                open={popover.open}
                onClose={popover.onClose}
                arrow="bottom-bottom"
                sx={{
                  width: 1000,
                  padding: 2,
                  background: 'white !important',
                  left: '310px !important',
                }}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
              >
                <MenuItem
                  disableRipple
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 2,
                    color: '#000',
                    background: 'white !important',
                    '&:hover': { backgroundColor: 'white !important' },
                  }}
                >
                  <Iconify
                    icon="mdi:close"
                    onClick={handleCloseFilters}
                    sx={{
                      width: 20,
                      height: 20,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      borderRadius: '50%',
                      backgroundColor: '#F4F6F8',
                      color: '#637381',
                    }}
                  />

                  <TextField
                    label="Customer ID"
                    size="small"
                    placeholder="Search.."
                    variant="outlined"
                    value={filters.customer_id}
                    onChange={(e) => handleFilterChange('customer_id', e.target.value)}
                    sx={{
                      flex: 1,
                      background: 'white !important',
                      '& .MuiOutlinedInput-root': {
                        '&:hover fieldset': {
                          borderColor: '#e0e0e0 !important',
                        },
                      },
                    }}
                  />

                  <TextField
                    label="Project Name"
                    size="small"
                    placeholder="Search.."
                    variant="outlined"
                    value={filters.project_name}
                    onChange={(e) => handleFilterChange('project_name', e.target.value)}
                    sx={{
                      flex: 1,
                      '& .MuiOutlinedInput-root': {
                        '&:hover fieldset': {
                          borderColor: '#e0e0e0 !important',
                        },
                      },
                    }}
                  />
                  <TextField
                    label="Chart Of Account"
                    size="small"
                    placeholder="Search.."
                    variant="outlined"
                    value={filters.account_chart}
                    onChange={(e) => handleFilterChange('account_chart', e.target.value)}
                    sx={{
                      flex: 1,
                      '& .MuiOutlinedInput-root': {
                        '&:hover fieldset': {
                          borderColor: '#e0e0e0 !important',
                        },
                      },
                    }}
                  />

                  <TextField
                    label="Chart Description"
                    size="small"
                    placeholder="Search.."
                    variant="outlined"
                    value={filters.account_chart_name}
                    onChange={(e) => handleFilterChange('account_chart_name', e.target.value)}
                    sx={{
                      flex: 1,
                      '& .MuiOutlinedInput-root': {
                        '&:hover fieldset': {
                          borderColor: '#e0e0e0 !important',
                        },
                      },
                    }}
                  />
                  <TextField
                    label="Chart Type"
                    size="small"
                    placeholder="Search.."
                    variant="outlined"
                    value={filters.account_chart_account_type_name}
                    onChange={(e) => handleFilterChange('account_chart_account_type_name', e.target.value)}
                    sx={{
                      flex: 1,
                      '& .MuiOutlinedInput-root': {
                        '&:hover fieldset': {
                          borderColor: '#e0e0e0 !important',
                        },
                      },
                    }}
                  />
                </MenuItem>
              </CustomPopover>

              <Card
                sx={{
                  boxShadow: '0px 0px 30px 0px #64748B1A',
                }}
              >
                <TableContainer sx={{ position: 'relative', overflow: 'unset' }}>
                  <TableSelectedAction
                    dense={table.dense}
                    numSelected={table.selected.length}
                    rowCount={tableData.length}
                    onSelectAllRows={(checked) =>
                      table.onSelectAllRows(
                        checked,
                        tableData.map((row) => row.id)
                      )
                    }
                    action={
                      <Tooltip title="Delete">
                        <IconButton color="primary" onClick={confirm.onTrue}>
                          <Iconify icon="solar:trash-bin-trash-bold" />
                        </IconButton>
                      </Tooltip>
                    }
                  />
                  <Scrollbar>
                    <Table size={table.dense ? 'small' : 'medium'} sx={{ minWidth: 960 }}>
                      <TableHeadCustom
                        order={table.order}
                        orderBy={table.orderBy}
                        headLabel={TABLE_HEAD}
                        rowCount={tableData.length}
                        numSelected={table.selected.length}
                        onSort={table.onSort}
                        onSelectAllRows={(checked) =>
                          table.onSelectAllRows(
                            checked,
                            tableData.map((row) => row.id)
                          )
                        }
                      />
                      <TableBody>
                        {dataFiltered
                          .slice(
                            table.page * table.rowsPerPage,
                            table.page * table.rowsPerPage + table.rowsPerPage
                          )
                          .map((row, index) => (
                            <UserTableRow
                              key={row.id}
                              row={row}
                              chartsAccountList={chartsAccountList}
                              bankInformation={bankInformation}
                              selected={table.selected.includes(row.id)}
                              onSelectRow={() => table.onSelectRow(row.id)}
                              serialNumber={table.page * table.rowsPerPage + index + 1}
                              reload={()=>getInvoice()}
                            />
                          ))}
                        <TableEmptyRows
                          height={denseHeight}
                          emptyRows={emptyRows(table.page, table.rowsPerPage, tableData.length)}
                        />
                        <TableNoData notFound={notFound} />
                      </TableBody>
                    </Table>
                  </Scrollbar>
                </TableContainer>
                <TablePaginationCustom
                  count={dataFiltered.length}
                  page={table.page}
                  rowsPerPage={table.rowsPerPage}
                  onPageChange={table.onChangePage}
                  onRowsPerPageChange={table.onChangeRowsPerPage}
                  dense={table.dense}
                  onChangeDense={table.onChangeDense}
                />
              </Card>
            </>
          )}
          {
            <CSVLink
              ref={csvLinkRef}
              filename="Invoices(Account Receivable).csv"
              headers={getCsvHeaders()}
              data={getCsvData(tableData)}
              style={{ display: 'none' }}
            />
          }
        </CardContent>
      </Card>
      {
        <CSVLink
          ref={csvLinkRef}
          filename="account_receiveable(Invoices).csv"
          headers={getCsvHeaders()}
          data={getCsvData(tableData)}
          style={{ display: 'none' }}
        />
      }
      <ProjectList
        open={add.value}
        onClose={add.onFalse}
        type={`subcontractor`}
      />
     

      <ImportDilaog
        open={create.value}
        onClose={create.onFalse}
        reload={() => { }}
        url={endpoints.risk_management.risk_register.identification.importFile} />
      <SettingModal
        open={modal.value}
        onClose={modal.onFalse}
      />
      <ConfirmDialog
        open={confirm.value}
        onClose={confirm.onFalse}
        title="Delete"
        content="Are you want to delete selected items?"
        action={
          <Button
            variant="contained"
            className="dark-button"
            onClick={() => {
              handleDeleteRows();
              confirm.onFalse();
            }}
          >
            Delete
          </Button>
        }
      />
      <ConfirmDialog
        open={remove.value}
        onClose={remove.onFalse}
        title="Delete"
        content={<>Are you sure want to delete these items?</>}
        action={
          <LoadingButton
            loading={deleteLoading}
            variant="contained"
            className="dark-button"
            onClick={() => {
              handleBulkDelete();
            }}
          >
            Delete
          </LoadingButton>
        }
      />
    </>
  );
};
export default Invoice;

function applyFilter({ inputData, comparator, filters }) {
  const { customer_id, project_name, account_chart, account_chart_name, account_chart_account_type_name, invoice_number } = filters;
  const stabilizedThis = inputData.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  inputData = stabilizedThis.map((el) => el[0]);
  if (customer_id) {
    inputData = inputData.filter((row) => row.customer_id.toString().includes(customer_id.toString()));
  }
  if (project_name) {
    inputData = inputData.filter((row) => row.project.name.toLowerCase().includes(project_name.toLowerCase()));
  }
  if (account_chart) {
    inputData = inputData.filter((row) => row.account_chart?.code.toString().includes(account_chart.toString()));
  }
  if (account_chart_name) {
    inputData = inputData.filter((row) => row.account_chart?.name.toLowerCase().includes(account_chart_name.toLowerCase()));
  }
  if (account_chart_account_type_name) {
    inputData = inputData.filter((row) => row.account_chart?.account_type?.name.toLowerCase().includes(account_chart_account_type_name.toLowerCase()));
  }
  return inputData;
}